import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ContextProvider } from './contexts/ContextProvider';
import { LoginContextProvider } from './contexts/LoginContext';
import { CartContextProvider } from './contexts/CartContext';
import { OrderContextProvider } from './contexts/OrderContext';
import { hydrate, render } from "react-dom";
const theme = createTheme({
  palette: {
    primary: {

      // light: will be calculated from palette.primary.main,
      main: '#52b2fc',
      contrastText: 'white',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',

      main: '#fa5a04',
      // dark: will be calculated from palette.secondary.main,
      contrastText: 'white',
    },
    success: {
      main: '#3ad654',
      contrastText: 'white',
    }
  },
});
// Wrap your application with the react-snap-specific code
if (typeof window !== 'undefined') {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <ContextProvider>
          <LoginContextProvider>
            <CartContextProvider>
              <OrderContextProvider>
                <App />
              </OrderContextProvider>
            </CartContextProvider>
          </LoginContextProvider>
        </ContextProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  // Render your application without StrictMode when pre-rendering with react-snap
  hydrate(
    <ThemeProvider theme={theme}>
      <ContextProvider>
        <LoginContextProvider>
          <CartContextProvider>
            <OrderContextProvider>
              <App />
            </OrderContextProvider>
          </CartContextProvider>
        </LoginContextProvider>
      </ContextProvider>
    </ThemeProvider>,
    document.getElementById('root') as HTMLElement
  );
}